import JsonArrayMapper from "@/assets/js/models/helpers/JsonArrayMapper";
import OrderGoogleSheetSend from "@/assets/js/models/GoogleSheet/OrderGoogleSheetSend";
export default class OrderGoogleSheetSendCollection extends JsonArrayMapper {
  constructor(data) {
    super(data, OrderGoogleSheetSend);
  }
}